var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"desktop"}},[_c('div',{staticClass:"container viewport",class:{ active: !_vm.header }},[_c('div',{staticClass:"content d-flex flex-row"},[_c('leftBar'),_c('mainPanel'),_c('rightBar',{staticClass:"flex-fill"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }